import React from 'react';
import BenefitTrackerPage from './BenefitTrackerPage';

const OperationalEfficiency = () => {
    return <BenefitTrackerPage benefitType='Operational Efficiency' title="Operational Efficiency" />;
};

export default OperationalEfficiency;